import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { getDefaultZIndex } from "./auth-service-tools182.js";
import { useProps } from "./auth-service-tools225.js";
import { factory } from "./auth-service-tools248.js";
import { DrawerBody } from "./auth-service-tools357.js";
import { DrawerCloseButton } from "./auth-service-tools358.js";
import { DrawerContent } from "./auth-service-tools359.js";
import { DrawerHeader } from "./auth-service-tools360.js";
import { DrawerOverlay } from "./auth-service-tools361.js";
import { DrawerRoot } from "./auth-service-tools362.js";
import { DrawerTitle } from "./auth-service-tools363.js";
import classes from "./auth-service-tools364.js";
const defaultProps = {
  closeOnClickOutside: true,
  withinPortal: true,
  lockScroll: true,
  trapFocus: true,
  returnFocus: true,
  closeOnEscape: true,
  keepMounted: false,
  zIndex: getDefaultZIndex("modal"),
  withOverlay: true,
  withCloseButton: true
};
const Drawer = factory((_props, ref) => {
  const {
    title,
    withOverlay,
    overlayProps,
    withCloseButton,
    closeButtonProps,
    children,
    ...others
  } = useProps("Drawer", defaultProps, _props);
  const hasHeader = !!title || withCloseButton;
  return /* @__PURE__ */jsxRuntimeExports.jsxs(DrawerRoot, {
    ref,
    ...others,
    children: [withOverlay && /* @__PURE__ */jsxRuntimeExports.jsx(DrawerOverlay, { ...overlayProps
    }), /* @__PURE__ */jsxRuntimeExports.jsxs(DrawerContent, {
      children: [hasHeader && /* @__PURE__ */jsxRuntimeExports.jsxs(DrawerHeader, {
        children: [title && /* @__PURE__ */jsxRuntimeExports.jsx(DrawerTitle, {
          children: title
        }), withCloseButton && /* @__PURE__ */jsxRuntimeExports.jsx(DrawerCloseButton, { ...closeButtonProps
        })]
      }), /* @__PURE__ */jsxRuntimeExports.jsx(DrawerBody, {
        children
      })]
    })]
  });
});
Drawer.classes = classes;
Drawer.displayName = "@mantine/core/Drawer";
Drawer.Root = DrawerRoot;
Drawer.Overlay = DrawerOverlay;
Drawer.Content = DrawerContent;
Drawer.Body = DrawerBody;
Drawer.Header = DrawerHeader;
Drawer.Title = DrawerTitle;
Drawer.CloseButton = DrawerCloseButton;
export { Drawer };